import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import tableEventsContent from './formGroupLiveApps/tableEventsContent';
import tableTeamsContent from './formGroupLiveApps/tableTeamsContent';
import tableAppBlackoutsPostalCodesCatalog from './tableAppBlackoutsPostalCodesCatalog';

export default {
  title: 'General',
  attributeName: 'teamsToCamera',
  fields: [
    {
      attributeName: 'id',
      label: 'Id',
      helpText: 'Id.',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      hidden:true
    },
    {
      attributeName: 'visible',
      label: 'WebSocket Visibility',
      helpText: 'Visibility of the WebSocket.',
      default: true,
      type: FormInputTypes.CHECKBOX,
    },
    {
      attributeName: 'offset',
      helpText: 'Offset of the WebSocket in milliseconds',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      label: 'WebSocket Offset (ms)',
      placeholder: 'milliseconds...',
    },
    {
      attributeName: 'eventsTable',
      type: FormInputTypes.TABLE,
      mode:'POPUP',
      helpText: '',
      configFile: tableEventsContent,

    },
    
  ],
};
